import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

export const constantRoutes = [
  { path: '/login', name: 'Login', component: () => import('@/views/login/index.vue'), meta: { title: '登录', hidden: true } },
  { path: '/404', name: '404', component: () => import('@/views/error/404.vue'), meta: { title: '404', hidden: true } }
]

export const asyncRoutes = [
  {
    path: '/', component: Layout, redirect: '/dashboard',
    children: [{ path: 'dashboard', name: 'Dashboard', component: () => import('@/views/dashboard/index.vue'), meta: { title: '控制台', icon: 'el-icon-s-home', affix: true } }]
  },
  {
    path: '/content', component: Layout, redirect: '/content/banner', meta: { title: '内容运营', icon: 'el-icon-picture-outline' },
    children: [
      { path: 'banner', name: 'ContentBanner', component: () => import('@/views/business/banner/index.vue'), meta: { title: '轮播图管理', icon: 'el-icon-picture' } },
      { path: 'announcement', name: 'ContentAnnouncement', component: () => import('@/views/operation/announcement/index.vue'), meta: { title: '公告管理', icon: 'el-icon-bell' } },
      { path: 'category', name: 'ContentCategory', component: () => import('@/views/business/category/index.vue'), meta: { title: '游戏分类', icon: 'el-icon-collection' } },
      { path: 'service', name: 'ContentService', component: () => import('@/views/business/service/index.vue'), meta: { title: '服务管理', icon: 'el-icon-goods' } }
    ]
  },
  {
    path: '/order-center', component: Layout, redirect: '/order-center/order', meta: { title: '订单中心', icon: 'el-icon-s-order' },
    children: [
      { path: 'order', name: 'OrderCenterOrder', component: () => import('@/views/business/order/index.vue'), meta: { title: '订单管理', icon: 'el-icon-document' } },
      { path: 'appeal', name: 'OrderCenterAppeal', component: () => import('@/views/operation/appeal/index.vue'), meta: { title: '申诉管理', icon: 'el-icon-warning' } }
    ]
  },
  {
    path: '/user-center', component: Layout, redirect: '/user-center/user', meta: { title: '用户中心', icon: 'el-icon-user-solid' },
    children: [
      { path: 'user', name: 'UserCenterUser', component: () => import('@/views/business/user/index.vue'), meta: { title: '用户列表', icon: 'el-icon-user' } },
      { path: 'realname', name: 'UserCenterRealname', component: () => import('@/views/operation/realname/index.vue'), meta: { title: '实名审核', icon: 'el-icon-postcard' } },
      { path: 'finance', name: 'UserCenterFinance', component: () => import('@/views/operation/userFinance/index.vue'), meta: { title: '用户财务', icon: 'el-icon-wallet' } }
    ]
  },
  {
    path: '/driver-center', component: Layout, redirect: '/driver-center/driver', meta: { title: '打手中心', icon: 'el-icon-s-cooperation' },
    children: [
      { path: 'driver', name: 'DriverCenterDriver', component: () => import('@/views/business/driver/index.vue'), meta: { title: '打手列表', icon: 'el-icon-s-custom' } },
      { path: 'apply', name: 'DriverCenterApply', component: () => import('@/views/business/driverApply/index.vue'), meta: { title: '入驻审核', icon: 'el-icon-s-check' } },
      { path: 'withdraw', name: 'DriverCenterWithdraw', component: () => import('@/views/business/withdraw/index.vue'), meta: { title: '提现管理', icon: 'el-icon-money' } }
    ]
  },
  {
    path: '/system', component: Layout, redirect: '/system/admin', meta: { title: '系统管理', icon: 'el-icon-setting' },
    children: [
      { path: 'admin', name: 'SystemAdmin', component: () => import('@/views/system/admin/index.vue'), meta: { title: '管理员', icon: 'el-icon-user' } },
      { path: 'role', name: 'SystemRole', component: () => import('@/views/system/role/index.vue'), meta: { title: '角色管理', icon: 'el-icon-s-custom' } },
      { path: 'permission', name: 'SystemPermission', component: () => import('@/views/system/permission/index.vue'), meta: { title: '菜单权限', icon: 'el-icon-menu' } },
      { path: 'wechat', name: 'SystemWechat', component: () => import('@/views/system/wechat/index.vue'), meta: { title: '微信配置', icon: 'el-icon-chat-dot-round' } }
    ]
  },
  {
    path: '/log', component: Layout, redirect: '/log/admin', meta: { title: '日志管理', icon: 'el-icon-document' },
    children: [
      { path: 'admin', name: 'LogAdmin', component: () => import('@/views/log/admin/index.vue'), meta: { title: '后台日志', icon: 'el-icon-notebook-2' } },
      { path: 'user', name: 'LogUser', component: () => import('@/views/log/user/index.vue'), meta: { title: '用户日志', icon: 'el-icon-mobile-phone' } },
      { path: 'driver', name: 'LogDriver', component: () => import('@/views/log/driver/index.vue'), meta: { title: '打手日志', icon: 'el-icon-phone' } }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new VueRouter({ mode: 'history', scrollBehavior: () => ({ y: 0 }), routes: constantRoutes })
const router = createRouter()
export function resetRouter() { const newRouter = createRouter(); router.matcher = newRouter.matcher }
export default router
